import Common_Contact_Form from "./common_contact_form";
import Footer from "./Footer";
import Header from "./Header";
import React from "react";
import SEO from "./SeoHelmet";
import metaConfig from "./SeoComponent";
import { useLocation } from "react-router-dom";

const JointVenturePartner = () => {
  const location = useLocation(); // Get the current location (path)
  const meta = metaConfig.jointventure;
  return (
    <div>
      <SEO {...meta} />

      <div class="container-fluid position-relative p-0">
        <div class="w-100 me-3 top_head">
          <div class="top_head align-items-center"></div>
        </div>
        <Header />
      </div>

      <div class="container-fluid Finance_joint_vent bg-breadcrumb">
        <div class="container text-center py-5" style={{ maxWidth: "900px" }}>
          <ol
            class="breadcrumb d-flex justify-content-center mb-0 wow fadeInDown"
            data-wow-delay="0.3s"
          ></ol>
          <h4
            class="text-white display-4 mb-4 wow fadeInDown"
            data-wow-delay="0.1s"
          >
            Stronger Together
          </h4>
        </div>
      </div>
      <div
        class="modal fade"
        id="searchModal"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-fullscreen">
          <div class="modal-content rounded-0">
            <div class="col-lg-12 m-auto modal-header justify-content-lg-end">
              <button
                type="button"
                class="btn-close justify-content-lg-end text-white"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="col-lg-9 m-auto modal-header align-items-center text-center">
              <h4
                class="modal-title mb-0 m-auto text-white"
                id="exampleModalLabel"
              >
                Search by keyword
              </h4>
            </div>
            <div class="modal-body align-items-center">
              <div class="input-group w-75 mx-auto d-flex">
                <input
                  type="search"
                  class="form-control p-3"
                  placeholder="keywords"
                  aria-describedby="search-icon-1"
                />
                <span
                  id="search-icon-1"
                  class="input-group-text btn border p-3"
                >
                  <i class="fa fa-search text-white"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="container-fluid innercontain ktig_services_page finance_details_1 overflow-hidden pt-5">
        <div class="container">
          <div class="row col-xl-10 pb-0 m-auto g-5">
            <div
              class="text-center mt-0 mx-auto wow fadeInUp"
              data-wow-delay="0.2s"
            >
              <h1 class="display-3 text-capitalize text-white">
                Joint Venture Partner
              </h1>
            </div>

            <div
              className="page_details_inner wow fadeInUp"
              data-wow-delay="0.2s"
            >
              <p className="text-white text-left">
                Co-venture associates are integral to KTIG’s growth and success,
                enabling us to achieve shared goals and unlock new
                opportunities. These partnerships are built on mutual trust,
                collaboration, and a shared vision to deliver innovative
                solutions and drive impactful change. By aligning with
                like-minded organizations, KTIG combines its expertise and
                resources with its partners to create synergies that benefit all
                stakeholders.
              </p>
              <p className="text-white text-left">
                Our co-venture associates bring valuable insights, industry
                experience, and complementary capabilities that strengthen
                KTIG’s ability to innovate and expand. Together, we tackle
                complex challenges, explore emerging markets, and deliver
                solutions that create lasting value for clients and communities.
                These partnerships allow us to diversify our expertise, share
                risks, and accelerate the implementation of ambitious projects
                that shape the future.
              </p>
              <p className="text-white text-left">
                KTIG is committed to fostering partnerships based on
                transparency, shared responsibility, and a focus on long-term
                success. We carefully select joint venture partners who align
                with our core values and strategic objectives. By working
                together, we aim to create transformative solutions that empower
                businesses, improve lives, and contribute to sustainable growth.
                Through the strength of our co-venture associates, KTIG
                continues to set benchmarks in innovation, collaboration, and
                value creation across industries.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="container-fluid overflow-hidden pb-5 p-0">
        <Common_Contact_Form />
      </div>

      <Footer />

      <a
        href="#"
        class="btn btn-secondary btn-lg-square rounded-circle back-to-top"
      >
        <i class="fa fa-arrow-up"></i>
      </a>
    </div>
  );
};

export default JointVenturePartner;
